var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcVisibilityBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1550_7986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2988 11.2035C19.507 9.02049 15.7135 6.4729 11.5732 6.4729C7.41811 6.4729 3.62443 9.03781 1.84763 11.2035C1.67221 11.4173 1.67221 11.7253 1.84763 11.9391C3.68191 14.1749 7.48433 16.6697 11.5732 16.6697C15.8074 16.6697 19.5848 14.0273 21.2988 11.9391C21.4742 11.7253 21.4742 11.4173 21.2988 11.2035ZM15.5119 11.5713C15.5119 13.7431 13.745 15.5101 11.5732 15.5101C9.40129 15.5101 7.63443 13.743 7.63443 11.5713C7.63443 9.39947 9.40133 7.63253 11.5732 7.63253C13.7452 7.63256 15.5119 9.3997 15.5119 11.5713ZM3.07915 11.5714C3.73177 10.8932 5.30536 9.42931 7.51433 8.48979C6.12806 10.3113 6.12752 12.8298 7.51367 14.6519C5.83413 13.9401 4.27392 12.8155 3.07915 11.5714ZM15.6321 14.6528C17.0184 12.8312 17.0189 10.3128 15.6328 8.49064C17.3123 9.20248 18.8725 10.3272 20.0673 11.5711C19.4147 12.2495 17.8411 13.7132 15.6321 14.6528Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60303 11.5715C9.60303 12.6586 10.4874 13.543 11.5745 13.543C12.6615 13.543 13.5459 12.6586 13.5459 11.5715C13.5459 10.4845 12.6615 9.6001 11.5745 9.6001C10.4874 9.6001 9.60303 10.4845 9.60303 11.5715ZM12.3862 11.5715C12.3862 12.0192 12.022 12.3833 11.5745 12.3833C11.1268 12.3833 10.7627 12.0192 10.7627 11.5715C10.7627 11.1239 11.1268 10.7598 11.5745 10.7598C12.022 10.7598 12.3862 11.1239 12.3862 11.5715Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5723 4.22684C11.8925 4.22684 12.1521 3.96723 12.1521 3.64701V2.29407C12.1521 1.97384 11.8925 1.71423 11.5723 1.71423C11.252 1.71423 10.9924 1.97384 10.9924 2.29407V3.64701C10.9924 3.96723 11.252 4.22684 11.5723 4.22684Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0326 5.00212C15.3107 5.16069 15.6649 5.06401 15.8236 4.78569L16.5952 3.43275C16.7539 3.15458 16.657 2.8005 16.3788 2.64182C16.1006 2.48318 15.7466 2.58001 15.5879 2.85825L14.8162 4.21119C14.6576 4.48932 14.7545 4.84344 15.0326 5.00212Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32226 4.78568C7.48091 5.06385 7.83499 5.16072 8.11319 5.00207C8.39136 4.84343 8.48823 4.48931 8.32959 4.21115L7.55795 2.8582C7.39931 2.58004 7.04514 2.48317 6.76702 2.64181C6.48885 2.80045 6.39198 3.15458 6.55062 3.43274L7.32226 4.78568Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5723 18.9158C11.252 18.9158 10.9924 19.1754 10.9924 19.4956V20.8485C10.9924 21.1688 11.252 21.4284 11.5723 21.4284C11.8925 21.4284 12.1521 21.1688 12.1521 20.8485V19.4956C12.1521 19.1754 11.8925 18.9158 11.5723 18.9158Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11319 18.1401C7.83503 17.9815 7.48094 18.0783 7.32226 18.3565L6.55062 19.7094C6.39198 19.9876 6.48885 20.3417 6.76702 20.5004C7.04522 20.659 7.3993 20.5621 7.55795 20.284L8.32959 18.931C8.48827 18.6529 8.39136 18.2987 8.11319 18.1401V18.1401Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8236 18.3565C15.6649 18.0783 15.3107 17.9815 15.0326 18.1401C14.7545 18.2987 14.6576 18.6528 14.8162 18.931L15.5879 20.2839C15.7465 20.5621 16.1006 20.659 16.3788 20.5004C16.657 20.3417 16.7539 19.9876 16.5952 19.7094L15.8236 18.3565Z",
    fill: "#303C4A",
    stroke: "#F9FAFF",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1550_7986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7143,
    height: 19.7143,
    fill: "white",
    transform: "translate(1.71436 1.71423)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityBlack);
export default __webpack_public_path__ + "static/media/ic-visibilityBlack.893a3b7d.svg";
export { ForwardRef as ReactComponent };